export const BASE_URL =
  process.env.NODE_ENV === 'development' ? '/v3' : process.env.REACT_APP_API_BASE_URL;
